import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Envelope Simple Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M243.79 31.508H12.21a9.65 9.65 0 0 0-9.65 9.649v164.037c0 10.658 8.64 19.299 19.299 19.298h212.283c10.657 0 19.298-8.64 19.298-19.298V41.157a9.65 9.65 0 0 0-9.65-9.65m-24.81 19.298L128 134.212 37.02 50.806Zm15.162 154.388H21.859V63.097l99.616 91.318a9.65 9.65 0 0 0 13.05 0l99.616-91.318z" }, null, -1)
  ])))
}
export default { render: render }